import React from "react";
import { Card } from "@/components/ui/card";

export function KpiCard({ label, value, accent = "text-slate-900", sub, testid }) {
  return (
    <Card className="p-4" data-testid={testid}>
      <p className="text-xs uppercase tracking-wider text-slate-500">{label}</p>
      <p className={`mt-1 font-heading text-xl font-bold ${accent}`}>{value}</p>
      {sub && <p className="mt-0.5 text-xs text-slate-400">{sub}</p>}
    </Card>
  );
}

export function Panel({ title, children, right }) {
  return (
    <Card className="p-5">
      <div className="mb-4 flex items-center justify-between">
        <h3 className="font-heading text-base font-semibold text-slate-900">{title}</h3>
        {right}
      </div>
      {children}
    </Card>
  );
}

export function StatRow({ items }) {
  return (
    <div className="grid grid-cols-2 gap-3 sm:grid-cols-3">
      {items.map((it) => (
        <div key={it.label} className="rounded-md border border-slate-200 p-3" data-testid={it.testid}>
          <p className="text-xs uppercase text-slate-500">{it.label}</p>
          <p className={`mt-1 font-heading text-lg font-bold ${it.accent || "text-slate-900"}`}>{it.value}</p>
        </div>
      ))}
    </div>
  );
}

export const CHART_COLORS = ["#4f46e5", "#0ea5e9", "#10b981", "#f59e0b", "#f43f5e", "#8b5cf6"];
